import { useState } from "react";

import { useGetDoctorsPatients } from "@/api/patients";
import SearchIcon from "@/assets/icons/search";
import AddPatientModal from "@/components/modals/add-patient-modal";
import { DataTable, useTable } from "@/components/table/data-table";
import { columns } from "@/components/table/patients/columns";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";

const PatientsTable = () => {
  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 10,
  });
  const [nameFilter, setNameFilter] = useState("");
  const [lastId, setLastId] = useState<number>();
  const [lastConsultationDate, setLastConsultationDate] = useState<Date>();
  const [take, setTake] = useState(10);

  const setPaginationCustom = (newPagination: {
    pageIndex: number;
    pageSize: number;
  }) => {
    if (newPagination.pageIndex < pagination.pageIndex && patientsPage) {
      setLastId(patientsPage?.data[0].id);
      setLastConsultationDate(patientsPage?.data[0].lastConsultationDate);
      setTake(-Math.abs(take));
    }
    if (newPagination.pageIndex > pagination.pageIndex && patientsPage) {
      setLastId(patientsPage.data[patientsPage.data.length - 1].id);
      setLastConsultationDate(
        patientsPage.data[patientsPage.data.length - 1].lastConsultationDate
      );
      setTake(Math.abs(take));
    }
    setPagination(newPagination);
  };

  const { data: patientsPage, isLoading } = useGetDoctorsPatients(
    pagination.pageIndex,
    take,
    nameFilter,
    lastId,
    lastConsultationDate
  );
  const data = patientsPage?.data;

  const table = useTable({
    data,
    columns,
    manualPagination: true,
    onPaginationChange: (updater) => {
      if (typeof updater !== "function") return;
      const newPagination = updater(table.getState().pagination);
      setPaginationCustom(newPagination);
    },
    state: {
      pagination,
    },
    getRowId: (original) => original.id.toString(),
  });

  return (
    <div className="flex flex-col w-full gap-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between w-full overflow-x-auto">
        <div className="text-xl font-semibold shrink-0">Mes patients</div>
        <div className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto">
          <Input
            placeholder="Rechercher un patient"
            className="w-full sm:w-[320px] pl-9"
            startIcon={
              <SearchIcon className="absolute left-4 top-1/2 -translate-y-1/2" />
            }
            onChange={(e) => {
              setLastId(undefined);
              setLastConsultationDate(undefined);
              setTake(Math.abs(take));
              setPagination({ pageIndex: 0, pageSize: 10 });
              setNameFilter(e.target.value);
            }}
            value={nameFilter}
          />
          <Button
            type="button"
            variant={"blue"}
            size={"blue"}
            className="whitespace-nowrap"
            onClick={() => setIsAddModalOpen(true)}
          >
            + Ajouter un patient
          </Button>
        </div>
      </div>
      <div className="w-full">
        <DataTable
          table={table}
          isLoading={isLoading}
          canNextPage={patientsPage?.meta.hasNextPage}
          canPreviousPage={patientsPage?.meta.hasPreviousPage}
        />
      </div>
      <AddPatientModal open={isAddModalOpen} setOpen={setIsAddModalOpen} />
    </div>
  );
};

export default PatientsTable;
